import { useState, useEffect } from "react";
import toast from "react-hot-toast";

const useLocation = () => {
  const [location, setLocation] = useState({
    latitude: 37.7749,
    longitude: -122.4194,
  });
  const [viewport, setViewport] = useState({
    latitude: 37.7749,
    longitude: -122.4194,
    zoom: 20,
  });
  const [requested, setRequested] = useState(false);

  const requestLocation = () => {
    // verify if support browser the location
    if ("geolocation" in navigator) {
      // get permissions for location
      navigator.permissions
        ?.query({ name: "geolocation" })
        .then((permissionsStatus) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              setLocation({ latitude, longitude });
              setViewport({ latitude, longitude });
              setRequested(true);
            },
            (err) => {
              //verify status of permissions
              if (permissionsStatus.state === "prompt") {
                //if user not take decision in accept permissions
                toast.error(
                  "Active los permisos de ubicación para que funcione correctamente el mapa",
                  3500
                );
                setRequested(true);
              } else if (permissionsStatus === "denied") {
                //if user denied permissions
                toast.error(
                  "Se negaron los permisos. No se pudo obtener la ubicación.",
                  3500
                );
                setRequested(true);
              }
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0,
            }
          );
        });
    } else {
      toast.error(
        "La geolocalización no está soportada por este navegador.",
        5000
      );
    }
  };

  useEffect(() => {
    !requested && requestLocation();
  });
  return { location, viewport, setViewport, requested, requestLocation };
};
export default useLocation;
